// extracted by mini-css-extract-plugin
export default {"operationButton":"operationButton-CoBAV","firstSelected":"firstSelected-EOIZM","first_selected_student":"first_selected_student-Y5Mn9"};